import { chooseDBTranslation } from 'utils/translations'
import { IRunOptions, Paragraph, TextRun } from 'docx'
import { CVData } from 'types/printInterfaces'
import { IHideSetting } from 'types/layoutInterfaces'
import { isDetailHidden } from '../hideSettings'
import { itemParagraphSpacing } from './itemHeading'
import { fontSize } from './pageLayout'
import { i18n as i18nType, TFunction } from 'i18next'

/**
 * Generates the reference section of a CV document.
 *
 * @param {type} i18n - the internationalization object
 * @param {CVData} data - the data object containing CV information
 * @param {type} t - the translation function
 * @param {IHideSetting | undefined} hideSetting - the hide setting of the references
 * @return {Paragraph[]} an array of paragraphs representing the reference section
 * @notExported
 */
const reference = (i18n: i18nType, data: CVData, t: TFunction, hideSetting?: IHideSetting): Paragraph[] => {
  // return reference section
  const references: Paragraph[] = []

  for (let i = 0; i < data.references.length; i++) {
    const reference = data.references[i]
    const rows: IRunOptions[][] = [
      ...(isDetailHidden(hideSetting, 'name')
        ? []
        : [
            [
              { text: `${t('print.reference.referee')}: `, bold: true },
              { text: `${reference.firstName} ${reference.lastName}` },
            ],
          ]),
      ...(isDetailHidden(hideSetting, 'company')
        ? []
        : [[{ text: `${t('print.reference.company')}: `, bold: true }, { text: reference.company }]]),
      ...(isDetailHidden(hideSetting, 'letter')
        ? []
        : [[{ text: chooseDBTranslation(i18n, reference).letter, size: fontSize.small }]]),
    ]

    references.push(
      new Paragraph({
        keepLines: true,
        style: 'CaleoNormal',
        spacing: itemParagraphSpacing,
        // each row after the first one starts on a new line
        children: rows.flatMap((row, index) =>
          row.map((options, runIndex) => new TextRun(runIndex === 0 && index > 0 ? { ...options, break: 1 } : options))
        ),
      })
    )
  }

  return references
}

export default reference
